import React, { FunctionComponent, useEffect } from "react";
import styles from "../css/Section7.module.css";
import ellipse from "../../assets/ellipse.png";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";

const Section7 = () => {
  const language = useSelector((state: any) => state.language.value);

  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    if (location.hash === "#order") {
      const element = document.getElementById("order");
      if (element) {
        element.scrollIntoView({ behavior: "smooth" });
      }
    }
  }, [location]);

  const handleScroll = () => {
    navigate("/preview");
    setTimeout(() => {
      const element = document.querySelector(".mainContent");
      element?.scrollIntoView({ behavior: "smooth" });
    }, 100);
  };

  return (
    <div
      className={styles.frag}
      style={{ backgroundColor: "#F9F6E9" }}
      id="order"
    >
      <div className={styles.mainContainer}>
        <div className={styles.header}>
          <div className={styles.orderBook}>
            <span className={styles.orderBook1}>
              {language == "RO" && "Comandă romanul"}
              {language == "EN" && "Order the novel"}
            </span>
            <span className={styles.spiritFreedom}>
              {language == "RO" && " SPIRIT LIBER"}
              {language == "EN" && " FREE SPIRIT"}
            </span>
            <span className={styles.orderFormat}>
              {" "}
              {language == "RO" && "în formatul tău preferat"}
              {language == "EN" && "in your preferred format"}
            </span>
          </div>
          <span className={styles.orderFormat2}>
            {language == "RO" &&
              "Comandă romanul SPIRIT LIBER în formatul tău preferat"}
            {language == "EN" &&
              "Order the novel FREE SPIRIT in your preferred format"}
          </span>
        </div>
        <div className={styles.noise} />
        <div className={styles.flexParent}>
          <div className={styles.groupB}>
            <div className={styles.paperVersion}>
              <div className={styles.iconBook}>
                <div className={styles.groupC}>
                  <div className={styles.iconBookD}>
                    <div className={styles.maskGroupE} />
                  </div>
                  <img src={ellipse} className={styles.ellipseF} />
                </div>
              </div>
              <span className={styles.paperVersion10}>
                {language == "RO" && (
                  <>
                    Cartea în varianta fizică
                    <br />
                    Copertă tare, calitate superioară, livrare rapidă.
                  </>
                )}
                {language == "EN" && (
                  <>
                    The physical book
                    <br />
                    Hardcover, premium quality, fast delivery.
                  </>
                )}
              </span>
            </div>
            <div onClick={handleScroll}>
              <button className={styles.button11}>
                <span className={styles.addToCart}>
                  {language == "RO" && "Comandă acum"}
                  {language == "EN" && "Order now"}
                </span>
              </button>
            </div>
            <div className={styles.rectangle12} />
          </div>
          <div className={styles.groupB}>
            <div className={styles.paperVersion}>
              <div className={styles.iconBook}>
                <div className={styles.groupC}>
                  <div className={styles.iconBookD}>
                    <div className={styles.maskGroupE2} />
                  </div>
                  <img src={ellipse} className={styles.ellipseF} />
                </div>
              </div>
              <span className={styles.paperVersion10}>
                {language == "RO" && (
                  <>
                    Cartea în format electronic
                    <br />
                    Ideală pentru Kindle și alte dispozitive. Descărcare
                    imediată.
                  </>
                )}
                {language == "EN" && (
                  <>
                    The e-book
                    <br />
                    Perfect for Kindle and other devices. Instant download.
                  </>
                )}
              </span>
            </div>
            <div onClick={handleScroll}>
              <button className={styles.button11}>
                <span className={styles.addToCart}>
                  {language == "RO" && "Comandă acum"}
                  {language == "EN" && "Order now"}
                </span>
              </button>
            </div>
            <div className={styles.rectangle12} />
          </div>
          <div className={styles.groupB}>
            <div className={styles.paperVersion}>
              <div className={styles.iconBook}>
                <div className={styles.groupC}>
                  <div className={styles.iconBookD}>
                    <div className={styles.maskGroupE3} />
                  </div>
                  <img src={ellipse} className={styles.ellipseF} />
                </div>
              </div>
              <span className={styles.paperVersion10}>
                {language == "RO" && (
                  <>
                    Cartea în format audio
                    <br />
                    Citită însăși de autoare, perfectă pentru cei care vor să
                    economisească timp.
                  </>
                )}
                {language == "EN" && (
                  <>
                    The audiobook
                    <br />
                    Ideal for those who wish to save time.
                  </>
                )}
              </span>
            </div>
            <div onClick={handleScroll}>
              <button className={styles.button11}>
                <span className={styles.addToCart}>
                  {language == "RO" && "Comandă acum"}
                  {language == "EN" && "Order now"}
                </span>
              </button>
            </div>
            <div className={styles.rectangle12} />
          </div>
        </div>
      </div>
    </div>
  );
};

export default Section7;
